import React from "react";
import { Link } from "react-router-dom";
import AdminConsole from "../../components/admin/AdminConsole";
import AdminNavbar from "../../components/admin/AdminNavbar";
import { useAccountOperator } from "../../scripts/AccountOperator";

import './adminpage.css'

const AdminPage = () => {
  const { ready, authenticated, backendUser, backendLoading } = useAccountOperator();

  if (!ready || backendLoading) {
    return (
      <div className='adminPage'>
        <div className='adminPageContainer'>
          <div className='adminPageTextContainer'>
            <div className='adminPageText'>
              <div>Backend is connecting...</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (!authenticated) {
    return (
      <div className='adminPage'>
        <div className='adminPageContainer'>
          <div className='adminPageTextContainer'>
            <div className='adminPageText'>
              <div>Use the Admin Login page to access the Admin Console.</div>
            </div>
            <div className='adminPageLink'>
              <Link className='adminPageLink' to="/admin/login">Admin Login →</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (!backendUser || backendUser.role !== "admin") {
    return (
      <div className='adminPage'>
        <div className='adminPageContainer'>
          <div className='adminPageTextContainer'>
            <div className='adminPageText'>
              <div>You are logged in with a regular User account.</div>
            </div>
            <div className='adminPageLink'>
              <Link className='adminPageLink' to="/admin/login">Admin Login →</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <AdminNavbar />
      <AdminConsole />
    </div>
  );
};

export default AdminPage;
